module.exports = __webpack_public_path__ + "media/images/game_icon/zh-tw/AB1027-be4f2b8e6a846e709b38adb111443280.png";